import React from "react";
import DashboardHomeView from "../../../views/dashboard/home";

const DashboardHome = () => {
  return <DashboardHomeView />;
};

export default DashboardHome;
